const sounds = {
    error: new Audio(require("./assets/error.mp3")),
    success: new Audio(require("./assets/ok.mp3"))
}

function error(vm, msg, err) {
    console.log(msg, err);
    sounds.error.play();
    return vm.$ons.notification.alert(msg, { title: "Error" });
}

function warn(vm, msg, err) {
    console.log(msg, err);
    sounds.error.play();
    return vm.$ons.notification.toast(msg, { timeout: 2000 });
}

function info(vm, msg) {
    return vm.$ons.notification.toast(msg, { timeout: 2000 });
}

function focus(el) {
    setTimeout(() => {
        const elem = document.getElementById(el);
        if (elem != null) elem.focus();
    }, 100);
}

function validateLabel(labelId) {
    return labelId.length === 9 || labelId.length === 10;
}



export default {
    error, warn, info, focus, validateLabel, sounds
};


// WEBPACK FOOTER //
// ./src/util.js